import { useMyAccountHasFeature } from '@/api/queries/me/useGetMyAccountFeatures';
import useGetProjectByIdOverview from '@/api/queries/project/useGetProjectByIdOverview';
import useGetProjectHeatLossEstimate from '@/api/queries/project/useGetProjectHeatLossEstimate';
import { PermissionGuard } from '@/ui/components/permissionGuard/PermissionGuard';
import { Card } from '@payaca/ambrosia';

import { DealsPermissions } from '@payaca/permissions/deals/deals.permissions';
import UntitledIcon from '@payaca/untitled-icons';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import DnoApplicationsCard from './DnoApplicationsCard';
import EnergyPerformanceCertificateCard from './EnergyPerformanceCertificateCard';
import HeatLossDetailsCard from './HeatLossDetailsCard';
import { SyncEnergyPerformanceCertificateButton } from './SyncEnergyPerformanceCertificateButton';

const PropertyPanel: FC = () => {
  /**
   * Router
   */
  const { projectId } = useParams<{ projectId: string }>();

  const { project } = useGetProjectByIdOverview(projectId);
  const hasEstimates = useMyAccountHasFeature('hasEstimates');
  const { heatLossEstimate } = useGetProjectHeatLossEstimate(
    hasEstimates ? projectId : undefined
  );

  const epcs = project?.addresses.site[0]?.energyPerformanceCertificates;
  const hasAnyEpcs = !!epcs?.length;

  return (
    <div className="@container space-y-4">
      {!project?.addresses.site.length && (
        <Card>
          <Card.Body>
            <h3>Energy Performance Certificate (EPC)</h3>
            <p>
              You must add a Site Address to the Project before fetching the EPC
              rating
            </p>
            {/*todo: make this button work*/}
            {/*<Button size="sm" variant="white">*/}
            {/*  <UntitledIcon name="plus.3" className="w-5 h-5" />*/}
            {/*  Add site address*/}
            {/*</Button>*/}
          </Card.Body>
        </Card>
      )}

      {!!project?.addresses.site.length && (
        <>
          {!hasAnyEpcs && (
            <Card>
              <Card.Body className="flex justify-between items-start">
                <div>
                  <h3>Energy Performance Certificate (EPC)</h3>

                  <p>
                    No Energy Performance Certificates have been fetched yet for
                    the Project site address
                  </p>
                </div>

                <SyncEnergyPerformanceCertificateButton
                  projectId={projectId}
                  addressId={project.addresses.site[0].publicId}
                  size="sm"
                  variant="white"
                >
                  <UntitledIcon name="search-lg.3" className="h-5 w-5" />
                  Search for EPC
                </SyncEnergyPerformanceCertificateButton>
              </Card.Body>
            </Card>
          )}

          {hasAnyEpcs && (
            <>
              <EnergyPerformanceCertificateCard
                projectId={projectId}
                siteAddressPublicId={project.addresses.site[0].publicId}
                energyPerformanceCertificate={epcs[0]}
              />
            </>
          )}
        </>
      )}

      {hasEstimates && heatLossEstimate && (
        <HeatLossDetailsCard heatLossEstimate={heatLossEstimate} />
      )}

      <PermissionGuard
        renderIfHasPermissions={[DealsPermissions.GET_COMPLIANCE_FORMS]}
      >
        <DnoApplicationsCard />
      </PermissionGuard>
    </div>
  );
};

export default PropertyPanel;
